
/* injects from baggage-loader */

'use strict';

function routeConfig($urlRouterProvider, $locationProvider) {
	'ngInject';
	
	// Default route
	$urlRouterProvider.otherwise('/');
	$locationProvider.html5Mode(true);

}

export default angular
  .module('index.routes', [])
  .config(routeConfig);